import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TickerCardComponent } from 'src/app/components/library/ticker-card/ticker-card.component';

@Component({
  selector: 'conversion-ticker',
  templateUrl: 'conversion-ticker.component.html',
  imports: [ TickerCardComponent, TranslateModule ],
})
export class ConversionTickerComponent {
}
